import ProductModifier from "./ProductModifier"

const ProductModifiers = ({modifiers, product}) => {
    
    return <div>
        {modifiers && modifiers.map(modifier => (
            <ProductModifier key={modifier.id} modifier={modifier} product={product}/>
        ))}
    </div>
}

export default ProductModifiers